import { render } from "./FoodMenuRoute.vue?vue&type=template&id=20ac4594"
import script from "./FoodMenuRoute.vue?vue&type=script&lang=js"
export * from "./FoodMenuRoute.vue?vue&type=script&lang=js"

import exportComponent from "D:\\perso\\miam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__